<template>
    <div>
        <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>详情列表</el-breadcrumb-item>
    </el-breadcrumb> -->
        <!-- 按时间查询 -->
        <div style="margin:15px 0">
            <el-date-picker
                v-model="dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="searchByDate"
                value-format="yyyy-MM-dd"
            >
            </el-date-picker>
        </div>
        <!-- 筛选按钮 -->
        <!-- <div style="margin:15px 0">
      <el-date-picker
        v-model="value"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
        @change="time"
      >
      </el-date-picker>
    </div> -->
        <div style="background-color:#FFF;">
            <div style="background-color:#f7f7f7;text-align:center">
                <!-- 订单标题 -->
                <el-row :gutter="0" style="font-size:14px">
                    <el-col :span="4">
                        <div
                            class="grid-content bg-purple"
                            style="padding:10px 0 10px 5px;font-size:14px;"
                        >
                            <span>图片</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div
                            class="grid-content bg-purple"
                            style="padding:10px 0 10px 5px"
                        >
                            <span>昵称</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div
                            class="grid-content bg-purple"
                            style="padding:10px 0 10px 5px"
                        >
                            <span>手机号</span>
                        </div>
                    </el-col>
                    <el-col :span="2">
                        <div
                            class="grid-content bg-purple"
                            style="padding:10px 0"
                        >
                            <span>金额</span>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div
                            class="grid-content bg-purple"
                            style="padding:10px 0"
                        >
                            <span>购买景区</span>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <!-- 订单列表 -->
            <div
                v-for="order in AllOrder"
                style="border:1px solid #e5e5e5;margin:15px 0"
            >
                <div
                    style="height:45px;line-height:45px; background-color:#f7f7f7;font-size:15px"
                >
                    <span style="margin:10px 50px 0 10px;font-weight: 600">{{
                        order.gmttime
                    }}</span
                    ><span>订单号:{{ order.out_trade_no }}</span>
                </div>
                <div>
                    <!-- 订单标题 -->
                    <el-row :gutter="0">
                        <el-col :span="4">
                            <div
                                class="grid-content bg-purple"
                                style="text-align:center;border-right:1px solid #e5e5e5;"
                            >
                                <img
                                    :src="order.area_pic"
                                    alt=""
                                    style="width:100px;height:100px"
                                />
                            </div>
                        </el-col>
                        <el-col
                            :span="6"
                            style="border-right:1px solid #e5e5e5;"
                        >
                            <div
                                class="grid-content bg-purple"
                                style="text-align:center;height:100px"
                            >
                                <span style="line-height:100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 100%;display: block;">{{
                                    order.nick_name
                                }}</span>
                            </div>
                        </el-col>
                        <el-col
                            :span="4"
                            style="border-right:1px solid #e5e5e5;"
                        >
                            <div
                                class="grid-content bg-purple"
                                style="text-align:center;height:100px"
                            >
                                <span style="line-height:100px">{{
                                    order.wx_phone
                                }}</span>
                            </div>
                        </el-col>
                        <el-col
                            :span="2"
                            style="border-right:1px solid #e5e5e5;"
                        >
                            <div
                                class="grid-content bg-purple"
                                style="text-align:center;height:100px"
                            >
                                <span style="line-height:100px">{{
                                    order.cost
                                }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div
                                class="grid-content bg-purple"
                                style="padding:40px 0;text-align:center"
                            >
                                <span style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 100%;display: block;">{{ order.area_name }}</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagesize"
            layout="total,  prev, pager, next, jumper"
            :total="total"
            style="text-align:right;margin:0 16px 10px 0;border-radius:20px;"
        >
        </el-pagination>
    </div>
</template>

<script>
import qs from "qs";
export default {
    data() {
        return {
            dateRange: "",
            AllOrder: [],
            the_date: "",
            currentPage: 1, //分页
            pagesize: 10,
            total: 0,
            startDate: "",
            endDate: ""
        };
    },
    methods: {
        //查询列表
        findScenicSpot() {
            var userData = qs.parse(sessionStorage.getItem("userData"));
            // console.log(userData, 11111111)
            var that = this;
            var salesInfoData = {
                area_id: userData.area_id,
                start_date: this.startDate,
                end_date: this.endDate,
                month_date: that.the_date,
                count: true,
                pageindex: this.currentPage,
                pagesize: 10
            };
            if (this.value && this.value.length === 2) {
                salesInfoData.start_date = this.value[0];
                salesInfoData.end_date = this.value[1];
                salesInfoData.month_date = "";
            }
            var salesInfoParams = {
                methodUrl: "/wechat/getOrderInfo",
                jsonParam: qs.stringify(salesInfoData)
            };
            this.$axios.postRequest(salesInfoParams).then(
                function(res) {
                    //成功之后处理逻辑
                    that.AllOrder = res.data.list;
                    console.log(that.AllOrder, 111);
                    for (var i = 0; i < that.AllOrder.length; i++) {
                        if (
                            that.AllOrder[i].order_lx == 2 &&
                            userData.area_id > 0
                        ) {
                            for (
                                var j = 0;
                                j < res.data.list[i].package_info.length;
                                j++
                            ) {
                                if (
                                    res.data.list[i].package_info[j].area_id ==
                                    userData.area_id
                                ) {
                                    // console.log(res.data.list[i].package_info[j].area_price, 4444)
                                    that.AllOrder[i].cost =
                                        res.data.list[i].package_info[
                                            j
                                        ].area_price;
                                    // console.log(res.data.list[i].package_info[j].area_price, j, 4444)
                                }
                            }
                        }
                    }

                    // 循环 that.AllOrder[]
                    // if(that.AllOrder[i].order_lx =2)
                    //   循环 遍历package_info 数组,
                    //  if(package_info[j].area_id = area_id)取出 area_id 为当前登录人所属景区的area_id
                    //      给 that.AllOrder[i].cost = that.AllOrder[i].package_info[j].area_price;

                    that.total = res.data.totalcount;
                },
                function(res) {
                    //失败之后处理逻辑
                    console.log("error:");
                }
            );
        },
        // 设置默认日期
        settingDate() {
            Date.prototype.format = function(fmt) {
                var o = {
                    "M+": this.getMonth() + 1, //月份
                    "d+": this.getDate(), //日
                    "h+": this.getHours(), //小时
                    "m+": this.getMinutes(), //分
                    "s+": this.getSeconds(), //秒
                    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                    S: this.getMilliseconds() //毫秒
                };
                if (/(y+)/.test(fmt)) {
                    fmt = fmt.replace(
                        RegExp.$1,
                        (this.getFullYear() + "").substr(4 - RegExp.$1.length)
                    );
                }
                for (var k in o) {
                    if (new RegExp("(" + k + ")").test(fmt)) {
                        fmt = fmt.replace(
                            RegExp.$1,
                            RegExp.$1.length == 1
                                ? o[k]
                                : ("00" + o[k]).substr(("" + o[k]).length)
                        );
                    }
                }
                return fmt;
            };
            var currentDate = new Date();
            var year = currentDate.getFullYear();
            var month = currentDate.getMonth();
            var sameMonthFirst = new Date(year, month, "01");
            var beg = sameMonthFirst.format("yyyy-MM-dd");
            this.startDate = beg;
            var nextMonthFirstDay = new Date(year, month + 1, "01");
            var end = new Date(
                nextMonthFirstDay.getTime() - 1000 * 60 * 60 * 24
            ).format("yyyy-MM-dd");
            this.endDate = end;
            this.dateRange = [beg, end]; //将值设置给插件绑定的数据
        },
        searchByDate(val) {
            // console.log(val, 1111111);
            this.startDate = val[0];
            this.endDate = val[1];
            this.currentPage = 1;
            this.findScenicSpot();
        },
        // 分页
        handleSizeChange(val) {
            // console.log(val, 123);
            this.pagesize = val;
            this.findScenicSpot();
        },
        handleCurrentChange(val) {
            // console.log(val, 123123);
            this.currentPage = val;
            this.findScenicSpot();
        }
    },
    mounted() {
        // console.log("**********************************");
        this.settingDate();
        this.findScenicSpot();
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/OrderDetails.vue